import { render, staticRenderFns } from "./DiscussionPublishForm.vue?vue&type=template&id=59cbde69&"
import script from "./DiscussionPublishForm.vue?vue&type=script&lang=js&"
export * from "./DiscussionPublishForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports